import { appProfileDaysG4Ar } from './golf4App.ar.js';
// Arabisch (ar), profileApp: zelfde vorm als profileApp.nl.ts. Over gewoontes, nooit over
// nationaliteit of afkomst; geloofsteksten respectvol en precies.
//
// LET OP: consent.version is gelijk aan PROFILE_CONSENT_VERSION. De hash in CONSENT_TEXT_HASHES
// dekt (nog) alleen nl en en; wijzigt de Nederlandse toestemmingstekst, vertaal deze dan opnieuw.
export const appProfileAr = {
    title: 'ما يناسب عائلتنا',
    intro: 'اختاروا ما يناسبكم، فتصبح القوائم أهدأ. كل شيء اختياري.',
    privacyLine: 'الوالدان فقط يمكنهما رؤية هذا وتغييره. الأقارب المربوطون لا يرونه أبدًا.',
    privacyLink: 'بيان الخصوصية',
    privacyPage: {
        title: 'بيان الخصوصية',
        back: 'العودة إلى التطبيق',
        intro: 'عن «ما يناسب عائلتنا»: المطبخ والدين والطعام والأيام الخاصة. باختصار ووضوح.',
        sections: [
            {
                title: 'لأي غرض',
                body: 'نستخدم اختياراتكم فقط لنحدد الخيارات التي ترونها: القوالب والرموز والوصفات والأيام الخاصة. لا للإعلانات، ولا لبناء ملفات عنكم، ولا للمشاركة.',
            },
            {
                title: 'أي بيانات',
                body: 'المطابخ والتقاليد، والدين (مع الممارسات والمذهب الذي اخترتموه)، وقواعد الطعام (مثل الحلال أو النباتي)، والاختلافات لكل فرد، و«يأكل شيئًا آخر» في وصفة، والأيام الخاصة التي فعّلتموها. الدين والحلال والكوشر، وأحيانًا التقاليد، بيانات شخصية خاصة (المادة 9 من اللائحة العامة لحماية البيانات AVG).',
            },
            {
                title: 'الأساس القانوني',
                body: 'موافقتك الصريحة (المادة 9، الفقرة 2، البند أ من AVG). يعطيها أحد الوالدين عن نفسه وعن الأطفال دون 16 سنة؛ ويمكن للبالغ الذي لديه حساب خاص أن يوافق بنفسه على اختلاف خاص به. كل شيء اختياري: بدون موافقة يعمل التطبيق بشكل عادي.',
            },
            {
                title: 'من يراها',
                body: 'الوالدان في عائلتكم فقط يريان الاختيارات نفسها. الجهاز اللوحي والتطبيق يعرضان فقط ما يناسب؛ وفي الطعام نذكر من لا يأكل شيئًا ما. الأقارب المربوطون والضيوف وروابط المشاركة وتغذيات الأجندة ورسائل الأخطاء وملفات السجل لا تحصل على الاختيارات أبدًا. الأيام الخاصة لا تظهر في تصدير الأجندة إلا إذا فعّلت ذلك بشكل منفصل.',
            },
            {
                title: 'إلى متى',
                body: 'ما دامت الموافقة سارية. سحب الموافقة يمسح الاختيارات فورًا؛ وتختفي من النسخ الاحتياطية خلال 90 يومًا. أما دليل الموافقة نفسه (من، ومتى، وأي نص، دون المحتوى) فنحتفظ به حتى 5 سنوات بعد السحب، أو حتى حذف حساب العائلة.',
            },
            {
                title: 'حقوقك',
                body: 'يمكنك رؤية بياناتك وتغييرها في الإعدادات · ما يناسب عائلتنا، وتنزيلها في الإعدادات · تنزيل البيانات (كل والد بياناته، والمسؤول كل شيء)، وسحب موافقتك (وهذا يمسح كل شيء) وطلب الحذف. إذا لم توافق على شيء، يمكنك تقديم شكوى إلى هيئة حماية البيانات الهولندية (Autoriteit Persoonsgegevens).',
            },
            {
                title: 'الجهة المسؤولة والتواصل',
                body: 'شركة AMUMIN B.V. مسؤولة عن هذه البيانات. تنزّل بياناتك بنفسك من الإعدادات. للأسئلة أو طلب الحذف تواصل مع AMUMIN B.V.؛ وما دام عنوان الخصوصية الثابت غير موجود أدناه بعد، فعن طريق مسؤول حساب عائلتكم. سيظهر هنا عنوان ثابت للخصوصية وبيانات السجل التجاري (KvK) قبل أن تتمكن عائلات أخرى من التسجيل.',
            },
        ],
    },
    settingsBody: 'المطبخ والدين والطعام والأيام الخاصة',
    saveBar: 'حفظ التغييرات',
    invite: {
        title: 'ما الذي يناسب عائلتكم؟',
        body: 'اختاروا المطبخ والدين والطعام، فترون غالبًا ما يناسبكم. هذا ليس ضروريًا.',
        start: 'ضبط',
        later: 'ليس الآن',
        never: 'لا، شكرًا',
    },
    otherParent: {
        title: 'ما يناسب عائلتكم',
        body: 'ضبط {name} ما يناسب عائلتكم: {what}. هل هذا صحيح بالنسبة لك أيضًا؟',
        titleNeutral: 'ما يناسبكم',
        bodyNeutral: 'ضبط {name} ما يناسبكم: {what}. هل هذا صحيح بالنسبة لك أيضًا؟',
        view: 'عرض',
    },
    wizard: {
        title: 'ما الذي يناسبكم؟',
        body: 'اختر فقط ما تريد؛ ويمكن أن يبقى الباقي فارغًا. يمكنك تعديل كل شيء لاحقًا.',
        skip: 'تخطٍّ',
        skipQuestion: 'تخطَّ هذا السؤال',
        next: 'التالي',
        done: 'تم',
        save: 'حفظ',
        nothingSaved: 'لم تختر شيئًا، لذلك لن نحفظ شيئًا.',
        step: '{n} من {total}',
        question: '{step} · السؤال {n} من {total}',
    },
    traditions: {
        title: 'المطبخ والتقاليد',
        body: 'أي مطابخ وتقاليد تخصكم؟ يمكنك اختيار أكثر من واحد.',
        hint: 'هذا عن العادات، لا عن الجنسية. نتذكر فقط أي المطابخ تحبون. نستخدم ذلك لترتيب الوصفات واقتراح الأعياد.',
        labels: {
            dutch: 'هولندي',
            turkish: 'تركي',
            moroccan: 'مغربي',
            surinamese: 'سورينامي',
            antillean: 'أنتيلي',
            indonesian: 'إندونيسي',
            moluccan: 'مولوكي',
            italian: 'إيطالي',
            polish: 'بولندي',
            middle_eastern: 'شرق أوسطي',
            other: 'غير ذلك',
        },
        otherKitchens: {
            title: 'أي مطابخ تحبون؟',
            more: 'مطابخ أخرى',
        },
    },
    suggestion: {
        title: 'هل يناسبكم هذا؟',
        body: 'أنت من يختار. يمكنك تغييره دائمًا.',
        accept: 'نعم، اعتمد هذا',
        decline: 'سأختار بنفسي',
        days: 'توجد أيضًا {sets} يمكن إضافتها. تفعّلها بنفسك في الأيام الخاصة.',
    },
    faiths: {
        title: 'الدين',
        body: 'فترى الخيارات المناسبة. يمكنك بعد ذلك تفعيل الأعياد بنفسك.',
        none: 'بلا دين',
        shows: 'سترى حينها {list}',
        /** Golf 6b: gewoontes bij het gekozen geloof, optioneel (niets voorgevinkt). */
        madhab: {
            title: 'ما المذهب الذي تتبعونه؟',
            body: 'بهذا نضبط وقت العصر بشكل صحيح، من بين أمور أخرى. يمكنكم تغييره في أي وقت.',
            hint: 'المساجد التركية، مثل مساجد ديانت وملّي غوروش، تتبع المذهب الحنفي. والمساجد المغربية تتبع غالبًا المذهب المالكي.',
            unknown: 'لا أعرف / تخطٍّ',
            labels: { hanafi: 'الحنفي', shafii: 'الشافعي', maliki: 'المالكي', hanbali: 'الحنبلي' },
        },
        practicesTitle: 'ما الذي يخصّكم؟',
        practicesHint: 'ضعوا علامة على ما تفعلونه. نجهّز ذلك فقط كموعد أو مهمة أو رمز. ويمكنكم ألا تختاروا شيئًا.',
        openHint: 'إذا لم تختر شيئًا، فلن تظهر الصلاة ودرس المسجد بين الاقتراحات (لكن البحث يجدها). اختر دينكم إذا أردت رؤيتها.',
        labels: {
            islam: 'الإسلام',
            christianity: 'المسيحية',
            judaism: 'اليهودية',
            hinduism: 'الهندوسية',
            other: 'دين آخر',
        },
    },
    food: {
        title: 'الطعام',
        body: 'الوصفات والمشتريات التي لا تناسب هذا نبعدها عن النظر. تجدها دائمًا بالبحث أو بـ «عرض الكل».',
        labels: {
            halal: 'حلال',
            no_pork: 'بلا لحم خنزير',
            no_beef: 'بلا لحم بقر',
            vegetarian: 'نباتي',
            vegan: 'نباتي صرف',
            kosher: 'كوشر',
            no_alcohol: 'بلا كحول',
        },
    },
    days: {
        ...appProfileDaysG4Ar,
        title: 'أيام خاصة في الأجندة',
        optional: 'اختياري',
        body: 'هل تريد أيامًا إضافية في الأجندة؟ العطل الرسمية الهولندية مفعّلة؛ والمجموعات الإضافية كلها مطفأة. فعّل ما تريد رؤيته.',
        perDay: 'اختر لكل يوم',
        more: 'أيام خاصة أخرى',
        next: 'القادم: {dates}',
        noDates: 'مواعيد هذه السنة ستأتي لاحقًا.',
        expected: '(متوقع)',
        expectedNote: 'قد يتغير اليوم بالضبط بيوم واحد.',
        expectedTag: 'متوقع',
        sheet: {
            expected: 'هذا اليوم لم يتحدد بعد.',
            when: 'يوافق {dates}.',
            confirm: 'تأكيد اليوم',
            confirmHint: 'أكّده أو انقله في «ما يناسب عائلتنا»، قسم الأيام الخاصة.',
        },
        eveBefore: 'يبدأ في الليلة السابقة عند غروب الشمس.',
        eitherOr: '{a} أو {b}',
        nl: {
            title: 'العطل الرسمية الهولندية',
            note: 'للجميع. مفعّلة في الأصل.',
            days: {
                nieuwjaarsdag: 'رأس السنة الميلادية',
                goede_vrijdag: 'الجمعة العظيمة',
                pasen: 'عيد الفصح',
                koningsdag: 'يوم الملك',
                bevrijdingsdag: 'يوم التحرير',
                hemelvaartsdag: 'عيد الصعود',
                pinksteren: 'عيد العنصرة',
                kerstmis: 'عيد الميلاد المجيد',
                moederdag: 'عيد الأم',
                vaderdag: 'عيد الأب',
                sinterklaas: 'سينتركلاس',
                oudejaarsavond: 'ليلة رأس السنة',
            },
        },
        dayNames: {
            ramadan_start: 'بداية رمضان',
            ramadan_end: 'آخر يوم في رمضان',
            eid_al_fitr: 'عيد الفطر',
            eid_al_adha: 'عيد الأضحى',
            islamic_new_year: 'رأس السنة الهجرية',
            mawlid: 'المولد النبوي',
        },
        tradition: {
            title: 'أي تقويم تتبعون؟',
            body: 'لا تحدد كل المساجد الأعياد بالطريقة نفسها.',
            options: {
                diyanet: 'تركيا (رئاسة الشؤون الدينية، تقويم ثابت)',
                saudi: 'السعودية (رؤية الهلال)',
                morocco: 'المغرب (رؤية الهلال، التأكيد في الليلة السابقة)',
                own_mosque: 'مسجدنا (±1 يوم)',
            },
            hints: {
                diyanet: 'المواعيد محددة مسبقًا لسنوات.',
                saudi: 'حتى الإعلان في الليلة السابقة ترى يومين محتملين.',
                morocco: 'غالبًا ما يكون بعد السعودية بيوم. حتى الإعلان ترى يومين محتملين.',
                own_mosque: 'ترى التقويم الثابت. إذا اختار مسجدكم يومًا قبله أو بعده، فصحّحه هنا.',
            },
            defaultNote: 'افتراضيًا: الجدول الثابت لديانت. اختاروا ما يتبعه مسجدكم.',
            confirmTitle: 'هل أُعلن بعد؟',
            confirmBody: 'اضغط على اليوم الذي اختاره مسجدكم، فيُثبَّت في الأجندة.',
            unknown: 'لم يُعلن بعد',
            confirmedNote: 'مثبّت في الأجندة.',
        },
        sets: {
            tr_national: 'الأعياد الوطنية التركية',
            keti_koti: 'كيتي كوتي',
            indies_remembrance: 'ذكرى 15 أغسطس',
            id_independence: 'يوم استقلال إندونيسيا',
            it_national: 'الأعياد الإيطالية',
            pl_national: 'الأعياد البولندية',
            islamic: 'الأعياد الإسلامية',
            christian: 'الأيام المسيحية',
            jewish: 'الأعياد اليهودية',
            hindu: 'الأعياد الهندوسية',
        },
        ics: {
            toggle: 'الأيام الخاصة أيضًا في تصدير الأجندة',
            warning: 'سيرى تطبيق الأجندة لديك (مثل Google) هذه الأيام.',
        },
    },
    flags: {
        pork: 'لحم الخنزير',
        beef: 'لحم البقر',
        meat: 'اللحم',
        fish: 'السمك',
        shellfish: 'المحار والقشريات',
        dairy: 'الألبان',
        egg: 'البيض',
        honey: 'العسل',
        gelatin: 'الجيلاتين',
        alcohol: 'الكحول',
    },
    kitchens: {
        dutch: 'هولندي',
        turkish: 'تركي',
        moroccan: 'مغربي',
        surinamese: 'سورينامي',
        antillean: 'أنتيلي',
        indonesian: 'إندونيسي',
        moluccan: 'مولوكي',
        italian: 'إيطالي',
        polish: 'بولندي',
        middle_eastern: 'شرق أوسطي',
        chinese: 'صيني',
        indian: 'هندي',
        mexican: 'مكسيكي',
        greek: 'يوناني',
        west_african: 'غرب أفريقي',
        central_african: 'وسط أفريقي',
        east_african: 'شرق أفريقي',
        american: 'أمريكي',
    },
    member: {
        follows: 'يتبع العائلة',
        differs: 'مختلف عن العائلة',
        reset: 'اتبع العائلة من جديد',
        plus: 'يتبع العائلة، مع {what}',
        minus: 'يتبع العائلة، بدون {what}',
        faithDiffers: 'الدين: {what}',
        notPossible: 'لا يمكنك ضبط هذا لـ {name} بشكل منفصل. هذا ممكن فقط إذا وافق {name} بنفسه بحساب خاص. حتى ذلك الحين يتبع {name} العائلة.',
        askSelf: 'اطلب من {name} أن يضبط هذا بنفسه.',
        shareLink: 'مشاركة الرابط',
    },
    consent: {
        version: '2026-09-25.4',
        title: 'هل توافق؟',
        text: 'الدين وقواعد الطعام والمطابخ قد تكون بيانات حساسة. نستخدمها فقط لنحدد الخيارات التي تراها.\nالوالدان فقط يمكنهما رؤية هذا وتغييره. الجهاز اللوحي والتطبيق يعرضان ما يناسب؛ وفي الطعام نذكر من لا يأكل شيئًا ما.\nمع بعض الاختيارات يمكنك إضافة أقسام إضافية إلى اللوحة. يراها حينها كل من في الغرفة.\nلا نشارك شيئًا مع الأقارب المربوطين أو في القوائم المشتركة. الأيام الخاصة لا تظهر في الأجندة أو في تصدير الأجندة إلا إذا فعّلت ذلك بنفسك.\nيمكنك السحب في أي وقت، ويُمسح كل شيء فورًا. ويختفي من النسخ الاحتياطية خلال 90 يومًا.\nشركة AMUMIN B.V. مسؤولة عن هذه البيانات. حقوقك مذكورة في بيان الخصوصية.',
        check: 'أوافق عن نفسي وعن أطفالي دون 16 سنة.',
        given: 'أعطى {name} الموافقة في {date}',
        /** Fijnslijpen: zonder bekende naam (geen "door  op"). */
        givenAt: 'أُعطيت الموافقة في {date}',
        renew: 'تغيّر الشرح. اقرأه من فضلك وأعطِ موافقتك من جديد.',
        withdraw: 'سحب الموافقة والمسح',
        withdrawConfirm: 'سنمسح المطابخ والدين وقواعد الطعام والأيام الخاصة لعائلتكم. بعدها ترى كل شيء من جديد. هل تتابع؟',
        withdrawn: 'تم المسح. ترى كل شيء من جديد.',
    },
    selfConsent: {
        title: 'هل هذا صحيح بالنسبة لك؟',
        text: 'تضبط لنفسك ما تؤمن به أو ما تأكله. نستخدمه فقط لنحدد الخيارات التي تراها، وفي الطعام نذكر اسمك إذا كان شيء لا يناسبك. أنت والوالدان في هذه العائلة فقط ترونه. السحب يمسحه فورًا.',
        check: 'أوافق عن نفسي.',
        withdraw: 'سحب موافقتي',
    },
    daySetsInline: {
        tr_national: 'الأعياد الوطنية التركية',
        keti_koti: 'كيتي كوتي',
        indies_remembrance: 'ذكرى 15 أغسطس',
        id_independence: 'يوم استقلال إندونيسيا',
        it_national: 'الأعياد الإيطالية',
        pl_national: 'الأعياد البولندية',
        islamic: 'الأعياد الإسلامية',
        christian: 'الأيام المسيحية',
        jewish: 'الأعياد اليهودية',
        hindu: 'الأعياد الهندوسية',
    },
    hidden: {
        showAll: 'عرض الكل',
        showLess: 'عرض أقل',
        count: {
            zero: 'لا خيارات مخفية',
            one: 'خيار واحد مخفي',
            two: 'خياران مخفيان',
            few: '{count} خيارات مخفية',
            many: '{count} خيارًا مخفيًا',
            other: '{count} خيار مخفي',
        },
        groupFood: 'مخفية لأنكم {rules}',
        groupFaith: 'تخص دينًا آخر',
        groupNotChosen: 'تظهر إذا اخترت {what}',
        groupFaithOpen: 'مخفية حتى تختاروا شيئًا في خانة الدين',
        /** Golf 6b: geloof gekozen, gewoonte niet aangevinkt. */
        groupPractice: 'غير مختارة في خانة الدين',
        practice: 'مخفية لأنكم لم تختاروا {practice} في خانة الدين. غيّر ذلك في الإعدادات.',
        change: 'تغيير',
        faith: 'تخص {faiths}. اخترتم شيئًا آخر.',
        faithNone: 'مخفية لأنكم اخترتم «بلا دين» في خانة الدين. غيّر ذلك في الإعدادات.',
        notChosen: 'تظهر إذا اخترت {what} في الإعدادات.',
        faithOpen: 'مخفية حتى تختاروا شيئًا في خانة الدين. غيّر ذلك في الإعدادات.',
        food: 'مخفية لأنكم {rules}. غيّر ذلك في الإعدادات.',
        variant: 'توجد بالفعل نسخة من هذه الوصفة في القائمة.',
        rulePhrase: {
            halal: 'تأكلون الحلال',
            no_pork: 'لا تأكلون لحم الخنزير',
            no_beef: 'لا تأكلون لحم البقر',
            vegetarian: 'تأكلون طعامًا نباتيًا',
            vegan: 'تأكلون طعامًا نباتيًا صرفًا',
            kosher: 'تأكلون الكوشر',
            no_alcohol: 'لا تشربون الكحول',
        },
    },
    warning: {
        contains: 'في هذا {ingredient}.',
        containsMany: 'في هذا {ingredient}.',
        person: {
            halal: '{names} يأكل الحلال.',
            no_pork: '{names} لا يأكل لحم الخنزير.',
            no_beef: '{names} لا يأكل لحم البقر.',
            vegetarian: '{names} يأكل طعامًا نباتيًا.',
            vegan: '{names} يأكل طعامًا نباتيًا صرفًا.',
            kosher: '{names} يأكل الكوشر.',
            no_alcohol: '{names} لا يشرب الكحول.',
        },
        people: {
            halal: '{names} يأكلون الحلال.',
            no_pork: '{names} لا يأكلون لحم الخنزير.',
            no_beef: '{names} لا يأكلون لحم البقر.',
            vegetarian: '{names} يأكلون طعامًا نباتيًا.',
            vegan: '{names} يأكلون طعامًا نباتيًا صرفًا.',
            kosher: '{names} يأكلون الكوشر.',
            no_alcohol: '{names} لا يشربون الكحول.',
        },
        everyone: {
            halal: 'أنتم تأكلون الحلال.',
            no_pork: 'أنتم لا تأكلون لحم الخنزير.',
            no_beef: 'أنتم لا تأكلون لحم البقر.',
            vegetarian: 'أنتم تأكلون طعامًا نباتيًا.',
            vegan: 'أنتم تأكلون طعامًا نباتيًا صرفًا.',
            kosher: 'أنتم تأكلون الكوشر.',
            no_alcohol: 'أنتم لا تشربون الكحول.',
        },
        check: 'انتبه: قد يحتوي هذا على {what}.',
        meatDairy: 'يجتمع هنا اللحم والألبان: {meat}، {dairy}.',
        item: {
            pork: 'في هذا لحم خنزير.',
            beef: 'في هذا لحم بقر.',
            meat: 'في هذا لحم.',
            fish: 'في هذا سمك.',
            shellfish: 'في هذا محار أو قشريات.',
            dairy: 'في هذا ألبان.',
            egg: 'في هذا بيض.',
            honey: 'في هذا عسل.',
            gelatin: 'في هذا غالبًا جيلاتين خنزير.',
            alcohol: 'في هذا كحول.',
        },
        swap: 'نصيحة: {swap} بدلًا من {ingredient}.',
        swapButton: 'استبدال',
        addAnyway: 'اتركه كما هو',
        add: 'حسنًا',
        eatsOther: '{name} يأكل شيئًا آخر',
        whoEats: 'من يأكل معنا؟',
        everyoneEats: 'الجميع',
        and: 'و',
    },
    screens: {
        practices: {
            prayer: 'الصلاة',
            wudu: 'الوضوء',
            mosque: 'المسجد (ودروسه)',
            quran: 'درس القرآن',
            church: 'الكنيسة',
            shabbat: 'السبت (شبات)',
            synagogue: 'الكنيس',
            mandir: 'المعبد الهندوسي',
        },
        noneHint: 'عندها نبعد خيارات الدين مثل الصلاة ودرس المسجد عن النظر.',
        otherFaithHint: 'تبقى الصلاة ظاهرة؛ أما خيارات الأديان المذكورة فلا.',
        stepLabel: 'الخطوة {n} من {total}',
        progress: 'السؤال {n} من {total}',
        noConsentYet: 'بدون موافقة لا نحفظ شيئًا.',
        saved: 'تم الحفظ. سترى غالبًا ما يناسبكم.',
        savedMember: 'تم الحفظ لـ {name}.',
        resetMember: '{name} يتبع العائلة من جديد.',
        savedSelf: 'تم الحفظ.',
        resetSelf: 'أنت تتبع العائلة من جديد.',
        selfWithdrawn: 'مُسحت اختياراتك الخاصة.',
        noChanges: 'لم يتغير شيء.',
        loadError: 'تعذّر تحميل هذا.',
        changed: 'لقد غيّرت شيئًا.',
        settingsCardBody: 'المطبخ والدين والطعام والأيام الخاصة',
        membersTitle: 'لكل فرد',
        membersIntro: 'العائلة هي الأساس. ويمكن لأي فرد أن يختلف.',
        consentTitle: 'الموافقة',
        appliesTo: 'تسري على: {list}',
        selfTag: '{name} (بنفسه)',
        kidsTag: '{list} (أطفال دون 16 سنة)',
        noConsent: 'لم تُعطَ موافقة بعد. نطلبها عند أول حفظ.',
        inviteLater: 'سنسأل مرة أخرى لاحقًا.',
        inviteNever: 'حسنًا. تجده دائمًا في الإعدادات.',
        otherParentWhat: 'المطبخ والدين والطعام',
        dayCount: 'اليوم {n} من {total}',
        daysOn: 'مفعّل',
        daysOff: 'مطفأ',
        lessDays: 'أيام خاصة أقل',
        offeredEmpty: 'اختر المطبخ أو الدين في الأعلى، فنقترح أيامًا مناسبة.',
        member: {
            title: 'تعديل',
            open: 'تعديل لـ {name}',
            faith: 'الدين',
            food: 'الطعام',
            foodHint: 'اختيارات العائلة محددة. ما تفعّله يُضاف، وما تطفئه لا يسري على {name}. اختيارات العائلة اللاحقة تُتبع تلقائيًا.',
            faithFollows: 'الدين: مثل العائلة',
            lapsed: '{name} يضبط هذا بنفسه الآن.',
            selfIntro: 'أنت تضبط هذا لنفسك.',
            selfGiven: 'أعطيت الموافقة عن نفسك.',
            withdrawSelfTitle: 'مسح اختيارك الخاص؟',
            withdrawSelfBody: 'ستتبع العائلة من جديد. ما ضبطته لنفسك نمسحه فورًا.',
            withdrawSelfConfirm: 'مسح',
            save: 'حفظ',
            linkCopied: 'تم نسخ الرابط.',
            notSetYet: 'اضبط أولًا ما يناسب العائلة واحفظه. بعدها يمكنك الاختلاف لكل فرد.',
        },
        self: {
            title: 'ما يناسبني',
            intro: 'هل دينك أو طعامك مختلف عن العائلة؟ اضبط ذلك هنا بنفسك. أنت ووالداك فقط ترونه.',
            parents: 'هذا يضبطه والداك. من عمر 16 سنة يمكنك أن تحدد هنا بنفسك ما يختلف لديك.',
            notYet: 'لم يضبط والداك بعد ما يناسب عائلتكم. بعد ذلك يمكنك اختيار ما يخصك هنا.',
            settingsBody: 'دينك وطعامك',
        },
    },
};
//# sourceMappingURL=profileApp.ar.js.map